<form #userform="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/auth']">Users</a> > {{ user.username || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" type="submit" mat-flat-button color="primary" (click)="save(userform.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>User Name</mat-label>
            <input #username="ngModel" type="text" matInput name="username" [(ngModel)]="user.username" required>
            <mat-error *ngIf="username.invalid && username.touched">Username is required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Role</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedRole" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onRoleKey($event)" matInput name="user_role">
              <mat-option *ngFor="let role of filteredRoles" [value]="role.id">{{ role.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Email</mat-label>
            <input #email="ngModel" type="text" matInput name="email" [(ngModel)]="user.email" required>
            <mat-error *ngIf="email.invalid && email.touched">Email is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div *ngIf="!user.id" class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Password</mat-label>
            <input #password="ngModel" type="password" matInput name="password" [(ngModel)]="user.password" required autocomplete="new-password">
            <mat-error *ngIf="password.invalid && password.touched">Password is required</mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="user.id" class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>New Password</mat-label>
            <input #password="ngModel" type="password" matInput name="password" [(ngModel)]="user.password" autocomplete="new-password">
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="users" [recordId]="user.id"></app-audit-log-viewer>
</form>
